import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { LogoMark } from "@/components/Logo";
import { SITE_NAME } from "@/lib/brand";
import { converterUrl } from "@/lib/converter";
const footerLink = "inline-flex min-h-11 items-center rounded-lg underline-offset-4 hover:underline";
export function SiteFooter() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LogoMark size={28} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-start gap-3">{t0}<div className="flex flex-col gap-0.5"><p className="font-semibold text-ink">{SITE_NAME}<span className="font-normal text-muted-foreground">{" "}·{" "}{converterUrl ? "\u201CPrivate by design.\u201D" : "\u201CYour files never leave your device.\u201D"}</span></p><p className="text-sm">Free PDF and image tools · No sign-up · No watermarks</p></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <footer className="mt-auto border-t"><div className="mx-auto flex max-w-[1200px] flex-wrap items-center justify-between gap-x-6 gap-y-3 px-4 py-6 text-[15px] text-muted-foreground sm:px-6">{t1}<nav aria-label="Footer" className="flex gap-5"><Link href="/privacy" className={footerLink}>Privacy</Link><Link href="/terms" className={footerLink}>Terms</Link><Link href="/about" className={footerLink}>About</Link></nav></div></footer>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}